/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
//import PropTypes from "prop-types"
import { withPrefix } from "gatsby";
import Helmet from "react-helmet";
import { LocaleConsumer } from "../components/Layout";
//import useSiteMetadata from "../components/_customHooks/useSiteMetaData";
import i18n from "../../config/i18n";

function SEO({
  lang,
  title,
  description,
  keywords,
  location,
  isArticle,
  image,
  seoImage,
}) {
  const tdcxCN = process.env.GATSBY_BUILD_SITE === "china";
  //const { siteUrl } = useSiteMetadata();
  const siteUrl = 'https://www.tdcx.com'
  const seo_base_url = process.env.CMS_API_URL;
  const getLocale = (locale) => {
    return locale.replace(/_/g, "-");
  };
  const regex = /(<([^>]+)>)/gi;
  const getFormattedText = (copy) => {
    if (regex.test(copy)) {
      return copy.replace(regex, "");
    } else {
      return copy;
    }
  };
  return (
    <LocaleConsumer>
      {({ locale, htmlLang }) => (
        <Helmet
          htmlAttributes={{
            lang: htmlLang,
          }}
          defaultTitle="TDCX"
        >
          <html lang="en" amp />
          <title itemProp="name" lang={lang}>
            {title}
          </title>

          {Object.keys(i18n).map((x, key) => (
            <link
              key={key}
              rel="alternate"
              hrefLang={i18n[x].hrefLang}
              href={`${siteUrl.slice(0, -1)}${
                i18n[x].path && i18n[x].path !== "en" ? `/${i18n[x].path}` : ""
              }${
                location.pathname.split(getLocale(locale))[1]
                  ? location.pathname.split(getLocale(locale))[1]
                  : location.pathname
              }`}
            />
          ))}
          <meta name="description" content={getFormattedText(description)} />
          <meta name="keywords" content={getFormattedText(keywords)} />
          <meta property="og:title" content={getFormattedText(title)} />
          <meta
            property="og:description"
            content={getFormattedText(description)}
          />
          <meta property="og:url" content={`${siteUrl}${location.pathname}`} />
          <meta
            property="og:image"
            content={
              seoImage
                ? seoImage
                : typeof image !== "undefined" || undefined
                ? `${siteUrl}${image}`
                : `${siteUrl}/TDCX-logo.png`
            }
          />
          <meta
            property="og:type"
            content={isArticle ? "article" : "website"}
          />
          <meta name="twitter:card" content="summary_large_image" />
          <script src={withPrefix("web-sdk.js")} type="text/javascript" />
          <script src={withPrefix("inside.js")} type="text/javascript" />
          {tdcxCN && (
              <meta name="360-site-verification" content="a1c7baaaddb77fa32f2259d7f74348b0" /> 
          )}
          {tdcxCN && (
            
            <meta http-equiv="Content-Type" content="text/html;charset=gb2312" />
            
          )}
           {tdcxCN && (
           
           <meta name="sogou_site_verification" content="88sSULCiiX" />
           
          )}
        </Helmet>
      )}
    </LocaleConsumer>
  );
}

export default SEO;
